import data from '../../../../shared/standards/nen7510.json';
export default data;
